import { render, staticRenderFns } from "./StoreJSON.vue?vue&type=template&id=472829d2&"
import script from "./StoreJSON.vue?vue&type=script&lang=ts&"
export * from "./StoreJSON.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports